import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getI18nLang } from "@/i18n";
import { trackPageView } from "@/lib/analytics";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Layout = () => {
  const location = useLocation();
  const { i18n } = useTranslation();

  const match = location.pathname.match(/^\/(zh|ja)(\/|$)/);
  const lang = match ? match[1] : "en";

  useEffect(() => {
    const target = getI18nLang(lang);
    if (i18n.language !== target) {
      i18n.changeLanguage(target);
    }
  }, [lang, i18n]);

  // Track page views
  useEffect(() => {
    trackPageView(location.pathname, document.title);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
